import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import type { InboxAttachment } from '../outreachTypes';

/**
 * The attachment chips of one answer (`outreach.inbox.attachments`, design outreach-v2 m1): always
 * five links, each with its line and whether the song has it.
 */
export function useInboxAttachments(accountId: number, replyUuid: string, enabled = true): InboxAttachment[] {
  const trpcAPI = useTRPCAPI();
  const { data } = useTRPCQuery(
    trpcAPI.outreach.inbox.attachments.queryOptions({ accountId, threadId: replyUuid }, { enabled, retry: false })
  );
  return (data as InboxAttachment[] | null | undefined) ?? [];
}
